export enum TrackType {
  ELEMENTS = 'ELEMENTS',
  SEGMENTS = 'SEGMENTS',
  CAPTIONS = 'CAPTIONS'
}
